import { Col, DatePicker, Input, Row, Select } from "antd";
import React, { memo } from "react";
import Icon from "@ant-design/icons";
import { toNonAccentVietnamese } from "utils";
import moment from "moment";

interface IFilter {
    search: string;
    setDateRange: React.Dispatch<any>;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
}

const Filter = (props: IFilter) => {
    const { search, setSearch, setDateRange } = props;

    const disabledDate = (current: any) => {
        return current && current > moment().endOf("day");
    };
    return (
        <Row gutter={[18, 16]}>
            <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={5} span={5}>
                <Input.Search
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Tên hoặc số điện thoại sale"
                    addonAfter={<Icon type="close-circle-o" rev={undefined} />}
                    value={search}
                    onChange={(e: any) => {
                        setSearch(e.target.value);
                    }}
                />
            </Col>
            {/* <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={5}>
                <DatePicker.RangePicker
                    style={{ width: "100%" }}
                    onChange={(date: any, dateStrings: string[]) => {
                        setDateRange({
                            fromDate: dateStrings[0]?.split("-").reverse().join("-"),
                            toDate: dateStrings[1]?.split("-").reverse().join("-"),
                        });
                    }}
                    format={"DD-MM-YYYY"}
                    placeholder={["Thời gian bắt đầu", "Thời gian kết thúc"]}
                    disabledDate={disabledDate}
                />
            </Col> */}
        </Row>
    );
};

export default memo(Filter);
